module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/publicsq_logo_main-e9bb37d04ca0595d6b5f23bee26effd5.svg";